import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CheckoutStore {
    selectedPayment: any;
    selectedVoucher: any;

    setPayment: (payment: any) => void;
    setVoucher: (voucher: any) => void;
    reset: () => void;
    }

    export const useCheckoutStore = create<CheckoutStore>()(
    persist(
        (set) => ({
                selectedPayment: null,
                selectedVoucher: null,

                setPayment: (payment) => set({ selectedPayment: payment }),
                setVoucher: (voucher) => set({ selectedVoucher: voucher }),
                reset: () => set({ selectedPayment: null, selectedVoucher: null }),
            }),
        {
        name: "checkout-storage",
        }
    )
);